//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PaymentQuery: any = {
    GetPaymentLogsListCustomerId: Backofficebff + '/v1/paymentlogs/customer',
    GetPaymentLogsListOrderNumber: Backofficebff + '/v1/paymentlogs/order',
    GetPaymentMethod: Backofficebff + '/v1/paymentlogs/paymentmethod',
    GetCountriesById: Backofficebff + '/fix/v1/payment/getcountriesbyid',
    GetCreditCardTypes: Backofficebff + '/fix/v1/payment/getcreditcardtypes',
    GetCreditCardTypesByCountryId: Backofficebff + '/fix/v1/payment/getcreditcardtypesbycountryid',
    GetExistInstallments: Backofficebff + '/fix/v1/payment/getexistinstallmentsbycountryid',
    GetCreditCardTypePaymentPlans: Backofficebff + '/fix/v1/payment/getcreditcardpaymentplangridbycountryid',
    GetKKIadePortalData: Backofficebff + '/v1/payment/getkkiadeportaldata',
    GetPaymentByReturnId: Backofficebff + '/v1/paymentlogs/GetPaymentByReturnId',
    GetPaymentByOrderId: Backofficebff + '/v1/paymentlogs/GetPaymentByOrderId',
    GetPaymentForReturn: Backofficebff + '/v1/paymentlogs/GetPaymentForReturn',
    GetCustomerPaymentMethodAvailabilityStatus:
        Backofficebff + '/v1/payment/getcustomerpaymentmethodavailabilitystatus',
    GetRefundMoneyBalance: Backofficebff + '/v1/payment/get-refund-money-balance',
    GetWalletTransactionByCustomerId: Backofficebff + '/v1/payment/get-wallet-transaction-by-customer-id',
    GetOrderPaymentsAndRefunds: Backofficebff + '/v1/payment/get-order-payments-and-refunds',
};
